import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const allowedItemsToReturnSchema_ = z.object({
  lineItemId: z.string(),
  variantId: z.string(),
  quantity: z.number(),
  parentVariantId: z.string().nullish(),
});

export const allowedItemsToReturnSchema: z.ZodType<AllowedItemsToReturn> =
  allowedItemsToReturnSchema_;
export interface AllowedItemsToReturn extends z.infer<
  typeof allowedItemsToReturnSchema_
> {}

export const giftReceiptSchema_ = z.object({
  teamId: zExt.objectId(),
  orderId: zExt.objectId(),
  allowedItemsToReturn: allowedItemsToReturnSchema_.array(),
  gifterName: z.string(),
  gifterEmail: z.string().nullish(),
  enabled: z.boolean().default(true),
  _id: zExt.objectId(),
  createdAt: z.date(),
  used: z.boolean().default(false),
  pdfUrl: z.string().nullish(),
});

export const giftReceiptSchema: z.ZodType<GiftReceipt> = giftReceiptSchema_;
export interface GiftReceipt extends z.infer<typeof giftReceiptSchema_> {}
